import { Button, type ButtonProps, ButtonVariation } from '../../../components/Button/Button';

interface RosterTableActionsProps {
  size?: ButtonProps['size'];
  onUpdateRoster?: () => void;
  onAddUser?: () => void;
  onExportRoster?: () => void;
  isExporting?: boolean;
  hasChanges?: boolean;
  canManageRoster?: boolean;
  'data-testid'?: string;
}

function RosterTableActions({
  size,
  onUpdateRoster,
  onAddUser,
  onExportRoster,
  isExporting = false,
  hasChanges = false,
  canManageRoster = false,
  'data-testid': dataTestId,
}: RosterTableActionsProps) {
  const baseTestId = dataTestId ?? 'roster-table-actions';

  return (
    <div
      className='roster-actions'
      data-testid={baseTestId}>
      {canManageRoster && (
        <Button
          data-testid={`${baseTestId}-update`}
          size={size}
          variation={ButtonVariation.SOLID}
          onClick={onUpdateRoster}>
          {hasChanges ? 'Update Roster' : 'Certify Roster'}
        </Button>
      )}
      {canManageRoster && (
        <Button
          data-testid={`${baseTestId}-add`}
          size={size}
          variation={ButtonVariation.SOLID}
          onClick={onAddUser}>
          Add User
        </Button>
      )}
      <Button
        data-testid={`${baseTestId}-export`}
        disabled={isExporting}
        size={size}
        variation={ButtonVariation.SOLID}
        onClick={onExportRoster}>
        {isExporting ? 'Exporting…' : 'Export Roster'}
      </Button>
    </div>
  );
}

export default RosterTableActions;
